import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import NewCouponForm from "../../components/coupon/NewCouponForm";

export default function NewCoupon() {
    const { productId } = useParams<{ productId: string }>();
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=coupon`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Novo Cupom"
                description="Criar novo cupom para o produto"
            />
            <PageBreadcrumb
                pageTitle="Novo Cupom"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewCouponForm
                    productId={productId}
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de cupons
                        navigate(`/products/edit/${productId}?tab=coupon`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar cupom:", error);
                    }}
                />
            </div>
        </>
    );
}